import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button } from "antd";

const HomeFaq = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const FaqObj = reduxChannel?.frequentlyFaq ?? {};

	const historyClick = (idx) => {
		let category = FaqObj?.ingredientList?.[idx];
		let url =
			"/together/channel/ingredients/detail/" +
			category?.ingredient_id +
			"?id=" +
			reduxChannel?.influencer_id;
		history.push(url);
	};

	if (FaqObj?.question) {
		return (
			<div
				style={{
					// backgroundColor: "#eaeff6",
					backgroundColor: "#e5f0ff",
				}}
			>
				<div
					className={`home-each home-header`}
					style={{
						// backgroundColor: "#eaeff6",
						backgroundColor: "#e5f0ff",
						// paddingBottom: 0,
						// marginBottom: "4em",
					}}
				>
					<div className={`home-images-group max-width-apply`}>
						<div className={`home-recommend-horizontal`}>
							<div className={`recommend-title`}>
								<p className={`type-kr`}>가장 많이 물어보는 질문</p>
								<p className={`title`}>Q. {FaqObj?.question}</p>
								<p
									className={`type-gray`}
									style={{
										color: "#212529",
										fontWeight: "400",
										fontSize: "1.3em",
									}}
								>
									{FaqObj?.answer}
								</p>
							</div>
							<div className={`home-hot-keywords-div`}></div>
						</div>
						<div className={`each-content-div faq-div`}>
							{FaqObj?.ingredientList?.map((item, idx) => {
								return (
									<div
										className={`notice-content`}
										key={`notice-mention-${idx}`}
									>
										<div className={`notice-text-div faq-each-div`}>
											<p className={`category-name`}>{item?.ingredient_name}</p>
											{item?.explanation && (
												<p className={`explanation`}>{item?.explanation}</p>
											)}
											<Button
												className={`faq-button mobile`}
												onClick={() => {
													historyClick(idx);
												}}
											>
												선별 리스트 보기
											</Button>

											{idx !== FaqObj?.ingredientList?.length - 1 && (
												<img
													src={`/assets/images/channel/faq-plus.png`}
													className={`faq-plus`}
													alt={`faq-plus`}
												/>
											)}
										</div>
										<Button
											className={`faq-button no-mobile`}
											onClick={() => {
												historyClick(idx);
											}}
										>
											선별 리스트 보기
										</Button>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	} else return <></>;
};
export default HomeFaq;
